import apiClient from 'services/api';
import { PortfolioAsset } from 'pages/Profile/api';

export const getReviewForm = (token: string) =>
  apiClient.get<Kudable.ReviewFormData>(`/public/review/${token}`);

export const submitReview = (token: string, body: Kudable.ReviewPayload) =>
  apiClient.post(`/public/review/${token}`, body);

export const submitGroupReview = (
  token: string,
  body: Kudable.GroupReviewPayload,
) => apiClient.post(`/public/review/${token}`, body);

export const requestReviewAssetUpload = (
  reviewToken: string,
  data: { content_type: string; size_bytes: number },
) =>
  apiClient.post<{ asset: PortfolioAsset; upload_url: string }>(
    `/public/review/${reviewToken}/assets/upload-url`,
    data,
  );

export const confirmReviewAssetUpload = (
  reviewToken: string,
  assetId: string,
) =>
  apiClient.post(
    `/public/review/${reviewToken}/assets/${assetId}/confirm`,
    {},
  );
